import { connect } from 'react-redux';
import { showMobileDeviationSharePopup } from '../../../Modals/redux/actionCreators';
const mapDispatchToProps = {
    onClick: showMobileDeviationSharePopup
};
export default connect(null, mapDispatchToProps);
